import type {ProvideThreeTextureSockets} from "#material/nodes/texture/provide-three-texture/definition"
import {provideThreeTextureDefinition} from "#material/nodes/texture/provide-three-texture/definition"
import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import type {CyclesReturns} from "#material/sockets/cycles"
import type {ThreeReturns} from "#material/sockets/three"
import type {Three as THREE} from "#material/three/exports"

@registerMaterialGraphNode
export class ProvideThreeTexture extends MaterialNode<ProvideThreeTextureSockets> {
    public override get definition() {
        return provideThreeTextureDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<ProvideThreeTextureSockets>> => {
        if (!this.parameters.settings.color) throw new Error("Color parameter is not set in ProvideThreeTexture node")

        //We need to cast here, because we don't want to call toColor() because some nodes like height to normal and bump require a raw texture node for finite differences
        return {color: this.parameters.settings.color as unknown as THREE.Node<"color">}
    }

    override toCycles = async (_: CyclesEvaluator): Promise<CyclesReturns<ProvideThreeTextureSockets>> => {
        throw new Error("ProvideThreeTexture node does not support Cycles evaluation")
    }
}
